export default () => {
  return /.*SSID*/.test(document.cookie);
};





// WEBPACK FOOTER //
// ./src/components/util/isCRMUser.js